import type { z } from 'zod';

import type { PermissionSchema } from './schemas';

type PermissionField = keyof z.infer<typeof PermissionSchema>;

/** What a permission's tag grants, sent with it wherever it is sent. */
const meaningAttributes = [
  'type',
  'subject',
  'categoryCode',
  'topicCode',
  'noteCode',
  'courseId',
] as const satisfies readonly PermissionField[];

const listAttributes = [
  'id',
  ...meaningAttributes,
  'label',
  'users',
  'permissionGroupIds',
] as const satisfies readonly PermissionField[];

const getAttributes = [...listAttributes] as const;

const updateAttributes = ['label'] as const satisfies readonly PermissionField[];

export const PermissionAttributes = {
  Meaning: meaningAttributes,
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
